<template>
  <div :class="['user-lookup', { collapsed: !user }]">
    <div class="heading">
      <strong>{{ user }}'s</strong> prompts
    </div>
    <a @click="close" class="close-lookup">(x)</a>

    <template v-if="userPrompts.length">
      <Prompts :prompts="userPrompts"></Prompts>
    </template>
    <div
      v-else
    >User not found! Search is case-sensitive and preserves whitespace - maybe check your search and try again?.</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "./utils.js";
import Prompts from "./table/prompts.vue";

export default {
  components: { Prompts },
  computed: {
    ...mapGetters(["userPrompts", "user", "promptmarks", "options"])
  },
  methods: {
    ...utils,
    close() {
      this.$store.commit("setUser", null);
      this.$store.commit("setUserPrompts", []);
    }
  }
};
</script>
